import { render, staticRenderFns } from "./JourneyConnectionToggle.vue?vue&type=template&id=b92b9b34&"
import script from "./JourneyConnectionToggle.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b92b9b34')) {
      api.createRecord('b92b9b34', component.options)
    } else {
      api.reload('b92b9b34', component.options)
    }
    module.hot.accept("./JourneyConnectionToggle.vue?vue&type=template&id=b92b9b34&", function () {
      api.rerender('b92b9b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/JourneyConnectionToggle.vue"
export default component.exports